import {remCalc} from '_themeUtils'
import {ThemeBreakpoints} from '_uiComponents'
import helpBox from './partials/help-box'

const emptySearchResultsBase = {
    EmptySearchResults: {
        baseStyle: ({headerSize}: {headerSize: ThemeBreakpoints}) => ({
            container: {
                pt: {
                    base: `${headerSize.base}px`,
                    sm: `${headerSize.sm}px`,
                    md: `${headerSize.md}px`,
                    lg: `${headerSize.lg}px`,
                    xl: `${headerSize.xl}px`,
                    '2xl': `${headerSize['2xl']}px`,
                },
                pb: {base: 'spacing.8', md: 'spacing.12'},
                px: {base: 'spacing.4', md: 'spacing.6', xl: 'spacing.16'},
            },
            header: {
                mt: {base: 'spacing.8', md: 'spacing.12'},
                mb: {base: 'spacing.12', md: 'spacing.16'},
            },
            title: {
                textStyle: {base: 'paragraphXl', md: 'displayXs'},
                letterSpacing: remCalc(1),
                textAlign: 'center',
                mb: 'spacing.5',
            },
            description: {
                textStyle: 'paragraphSm',
                textAlign: 'center',
                letterSpacing: remCalc(0.6),
            },
            searchQuery: {
                fontWeight: 400,
                fontStyle: 'italic',
            },
            suggestionLabel: {
                letterSpacing: remCalc(1),
                textStyle: 'paragraphSm',
                fontWeight: 400,
            },
            suggestionsTitle: {
                textAlign: {base: 'center', md: 'left'},
                textStyle: {base: 'paragraphMd', md: 'paragraphLg', xl: 'displayXs'},
                mb: {base: 'spacing.8', xl: 'spacing.10'},
            },
            storiesTitle: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(3),
                fontWeight: 500,
                textTransform: 'uppercase',
                mt: 'spacing.8',
                mb: 'spacing.3',
            },
            grid: {
                columns: {base: 1, lg: 2},
                spacing: {base: 0, lg: 'spacing.12'},
            },
            storiesGrid: {
                columns: {base: 1, md: 2, lg: 2},
                spacing: 'spacing.4',
            },
            seeAllLinkWrapper: {
                w: 'full',
                justifyContent: 'flex-end',
                mt: 'spacing.2',
                mb: 'spacing.3',
            },
            seeAllLink: {
                textStyle: 'paragraphXs',
                fontWeight: 400,
                letterSpacing: remCalc(1),
            },
        }),
    },
}

const emptySearchResults = {
    ...emptySearchResultsBase,
    ...helpBox,
}

export default emptySearchResults
